import React, { useState, useEffect, useRef } from "react";
import { PhoneNumberUtil } from "google-libphonenumber";
import { Button, Form, Spinner } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../My Queues/queues.css";
import "react-image-crop/dist/ReactCrop.css";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { toast } from "react-toastify";
import { authenticatedRequest } from "../../config/axios";
import "react-quill/dist/quill.snow.css";
import GeneratePdf from "../../My Queues/GeneratePdf";
import { useTranslation } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import pdfIcon from "../../assets/images/icons/pdf.png";
import imageIcon from "../../assets/images/icons/image-icon.png";
import Swal from "sweetalert2";

import $ from "jquery";
import {
  doctorSetPrescriptionSettings,
  userGetUserProfile,
  doctorGetTemplate,
  doctorSaveTemplate,
  doctorUpdateTemplate,
  documentView,
  doctorGeneratePdf,
  doctorCreatePrescription,
} from "../../config/service";
import axios from "axios";
import { serverPath } from "../../config/key";
import AddFieldModal from "./AddFieldModal";
import DeleteFieldModal from "./DeleteFieldModal";
import "./CreatePrescription.css";
import AddTemplateModal from "./AddTemplate";
import DeleteTemplateModal from "./DeleteTemplateModal";
import TemplateSearchList from "./SearchedList";
import AllDocumentModel from "../DoctorDashboard/AllDocumentModel";
import {
  checkEmailFormate,
  isMobile,
  validateIsraeliID,
} from "../../utils/function";

let typing = false;
let resetData = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  clientGender: "",
  dob: "",
  age: "",
  clientDOB: "",
};

const customStyles = {
  container: (provided) => ({
    ...provided,
    width: "100%",
  }),
  option: (provided) => ({
    ...provided,
    background: "transparent",
    color: "#000",
    fontWeight: "500",
    fontSize: "18px",
    padding: "10px 20px",
    lineHeight: "16px",
    cursor: "pointer",
    borderRadius: "0px",
    ":hover": {
      background: "#1E0F3C",
      borderRadius: "5px",
      color: "#E9E7EC",
    },
  }),
  control: () => ({
    background: "transparent",
    border: "1px solid #ced4da",
    borderRadius: "5px",
    color: "#000",
    display: "flex",
    alignItem: "center",
    height: "43px",
    margin: "0px",
    cursor: "pointer",
    fontSize: "18px",
    fontWeight: "500",
    ":hover": {
      background: "transparent",
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontWeight: "500",
    fontSize: "18px",
    color: "#000",
  }),
  input: (provided) => ({
    ...provided,
    color: "#000",
    fontWeight: "500",
    fontSize: "16px !important",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "2px 20px",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    paddingRight: "20px",
    color: "#858585c7",
  }),
};

const RxSummaryComponent = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [key, setKey] = useState("Summary");
  const lang = localStorage.getItem("lang");
  const userId = localStorage.getItem("userId");
  const [value, setValue] = useState(null);
  const [formValue, setformValue] = useState({
    first_name: "",
    last_name: "",
    email: "",
    id: "",
    phone: "",
    clientGender: "",
    age: "",
    clientDOB: "",
  });
  const [apiData, setApiData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    id: "",
    phone: "",
    clientGender: "",
    age: "",
    clientDOB: "",
    isPassportNum: "",
  });
  const initialFieldArray = [
    {
      name: "referral_reason",
      value: "referral_reason",
      label: t("Reason for referral"),
    },
    {
      name: "background_details",
      value: "background_details",
      label: t("Background Details"),
    },
    { name: "diagnsis", value: "diagnsis", label: t("Diagonosis") },
    {
      name: "treatment_program",
      value: "treatment_program",
      label: t("Treatment Program"),
    },
  ];

  const [payloadData, setPayloadData] = useState("");

  const [prescriptionData, setPrescriptionData] = useState([]);
  const [generateUpdateModal, setGenerateupdateModal] = useState(false);
  const [summary, setSummary] = useState({
    background_details: "",
    diagnsis: "",
    referral_reason: "",
    treatment_program: "",
  });
  const [isNewValue, setisNewValue] = useState(true);
  const [errors, setErrors] = useState({});

  const handleClose4 = () => setGenerateupdateModal(false);
  const [medicineList, setMedicineList] = useState([]);
  const [searchKey, setSearchKey] = useState([]);
  const [selectedSec, setSelectedSec] = useState(-1);
  const [medicineValue, setMedicineValue] = useState("");
  const [doctorData, setDoctorData] = useState("");
  const [medicineMetaDocData, setMedicineMetaDocData] = useState("");

  const [consultId, setConsultId] = useState("");
  const [consultField, setConsultField] = useState();
  const [doctorObj, setDoctorObj] = useState();
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [addTemplate, setAddTemplate] = useState({
    templateName: "",
    templateText: "",
    templateField: [],
  });
  const [templateList, setTemplateList] = useState([]);
  const [isEditTemp, setIsEditTemp] = useState(false);
  const [templateId, setTemplateId] = useState("");
  const [deleteTempModal, setDeleteTempModal] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [filteredTemplate, setFilteredTemplate] = useState([]);
  const [targetInput, setTargetInput] = useState("");
  const [showFieldModal, setShowFieldModal] = useState(false);
  const [deleteFieldModal, setDeleteFieldModal] = useState(false);
  const [addField, setAddField] = useState({
    fieldName: "",
    fieldPosition: "",
    fieldPermanentStatus: "",
  });
  const [additionalData, setAdditionalData] = useState({});

  const [summaryFieldArray, setSummaryFieldArray] = useState(initialFieldArray);
  const [cleared, setCleared] = React.useState(false);
  const [rxMeetingId, setRxMeetingId] = useState("");
  const [openModel, setOpenModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [docIndex, setDocIndex] = useState();
  const [docURL, setDocURL] = useState("");
  const [allPdfDocument, setAllPdfDocument] = useState([]);
  const [showInputField, setShowInputField] = useState(false);
  const [showPatientInputField, setShowPatientInputField] = useState(false);
  const [combineAddress, setCombineAddress] = useState("");
  const [combinePatientAddress, setPatientCombineAddress] = useState("");
  const [medicMetaDetails, setMedicMetaDetails] = useState({});
  const [prescriptionIndex, setPrescriptionIndex] = useState();
  const [isPassport, setIsPassport] = useState(false);
  const [isManualType, setIsManualType] = useState(false);
  const [diagonosisError, setDiagonosisError] = useState(false);
  const [followUp, setFollowUp] = useState({});
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [isSyrup, setIsSyrup] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  const handleCheckDoctorAddress = () => {
    const fullAddress = medicineMetaDocData?.clientAddress;
    if (
      fullAddress?.city &&
      fullAddress?.house &&
      fullAddress?.pincode &&
      fullAddress?.street
    ) {
      setShowInputField(true);
      setCombineAddress(
        medicineMetaDocData.phone +
        " " +
        fullAddress?.street +
        " " +
        fullAddress?.house +
        " " +
        fullAddress?.city +
        " " +
        fullAddress?.pincode
      );
    } else {
      setShowInputField(false);
    }
  };

  const handleCheckPatientAddress = () => {
    if (
      formValue?.patient_city &&
      formValue?.patient_houseno &&
      formValue?.patient_pincode &&
      formValue?.patient_street
    ) {
      setShowPatientInputField(true);
      setPatientCombineAddress(
        formValue.phone +
        " " +
        formValue?.patient_street +
        " " +
        formValue?.patient_houseno +
        " " +
        formValue?.patient_city +
        " " +
        formValue?.patient_pincode
      );
      if (
        medicineValue &&
        Object.keys(medicineValue).length > 0 &&
        prescriptionIndex >= 0
      ) {
        enableMedicForm(medicineValue, prescriptionIndex);
      }
    } else {
      setShowPatientInputField(false);
    }
  };

  const handleEditInputField = () => {
    setShowInputField(false);
  };

  const handlePatientEditInputField = () => {
    setShowPatientInputField(false);
  };

  useEffect(() => {
    handleCheckDoctorAddress();
  }, [medicineMetaDocData?.clientAddress]);

  useEffect(() => {
    handleCheckPatientAddress();
  }, [formValue]);

  React.useEffect(() => {
    if (cleared) {
      setValue(null);
      const timeout = setTimeout(() => {
        setCleared(false);
      }, 1500);

      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => { };
  }, [cleared]);

  const wrapperRef = useRef([]);
  useOutsideAlerter(wrapperRef);

  const { meetingDetail } = location.state || {};
  useEffect(() => {
    if (meetingDetail) {
      const patientData = meetingDetail?.userDetails;
      setFollowUp(meetingDetail?.userDetails);
      setformValue({
        ...formValue,
        first_name: patientData?.first_name,
        last_name: patientData?.last_name,
        email: patientData?.email,
        id: patientData?.id,
        phone: patientData?.phone,
        clientGender: patientData?.clientGender,
        age: meetingDetail?.patientAge,
      });
      setConsultId(meetingDetail?.consultingFieldId);
      setAllPdfDocument(meetingDetail?.documents);
      if (Object.hasOwn(meetingDetail?.userDetails, "passportNumber")) {
        setIsPassport(meetingDetail?.userDetails?.passportNumber);
      }
      const parsedDate = moment(patientData.clientDOB);
      setValue(parsedDate);
    }
  }, [meetingDetail]);

  const continuingCare = [
    "הטיפול הסתיים",
    "הופנה לביצוע בדיקות",
    "לא מתאים לאונליין - הופנה לטיפול פרונטלי",
    "הזמנה להמשך מעקב פרונטלי",
    "הזמנה להמשך מעקב אונליין",
  ];
  const quantityArray = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];
  const timesArray = [
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
  ];

  // const genderArr = [
  //   { value: "Male", label: t("Male") },
  //   { value: "Female", label: t("Female") },
  // ];

  const handlePeriodArray = () => {
    let periodArray = [];
    for (let i = 1; i <= 180; i++) {
      periodArray.push({ value: i, label: i });
    }
    return periodArray;
  };
  const frequencyArray = [
    { value: "day", label: t("day") },
    { value: "48 hours", label: t("48 hours") },
    { value: "72 hours", label: t("72 hours") },
    { value: "week", label: t("week") },
    { value: "month", label: t("month") },
  ];
  const durationArray = [
    { value: "day", label: t("days") },
    { value: "48 hours", label: t("48 hours") },
    { value: "72 hours", label: t("72 hours") },
    { value: "week", label: t("weeks") },
    { value: "month", label: t("months") },
  ];

  const unitOrder = ["day", "48 hours", "72 hours", "week", "month"];

  // Filter durationArray based on selected frequencyUnit
  const getFilteredDurationOptions = (frequencyUnit) => {
    if (!frequencyUnit) return []; // Return empty array if no frequencyUnit (to disable Select)
    const frequencyIndex = unitOrder.indexOf(frequencyUnit);
    return durationArray.filter(
      (option) => unitOrder.indexOf(option.value) >= frequencyIndex
    );
  };

  function useOutsideAlerter(refs) {
    useEffect(() => {
      function handleClickOutside(event) {
        const isOutside = refs.current.every(
          (ref) => ref && !ref.contains(event.target)
        );

        if (isOutside) {
          setSelectedSec(-1);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [refs]);
  }

  const handleMedicine = (value, name, index) => {
    setMedicineValue(value);
    setPrescriptionIndex(index);
    enableMedicForm(value, index);
    const copy = [...prescriptionData];
    copy[index]["name"] = value?.Name;
    copy[index]["medicineId"] = value?._id;
    setPrescriptionData(copy);
    const syrupCopy = [...isSyrup];
    syrupCopy[index] = value?.ItemForm?.trim() === "SYR";
    setIsSyrup(syrupCopy);
    if (name === "inputVal" && medicineValue === "") {
      setSelectedSec(index);
    }
    if (name === "listVal") {
      setSelectedSec(-1);
    }
  };

  const enableMedicForm = (value, index) => {
    const isSamObj = medicMetaDetails;
    isSamObj[index] = value?.IsSam;
    setMedicMetaDetails(isSamObj);
    const prescribeData = [...prescriptionData];
    prescribeData[index]["isSam"] = value?.IsSam;
    if (value?.IsSam) {
      prescribeData[index]["patient_street"] = formValue?.patient_street || "";
      prescribeData[index]["patient_houseno"] =
        formValue?.patient_houseno || "";
      prescribeData[index]["patient_city"] = formValue?.patient_city || "";
      prescribeData[index]["patient_pincode"] =
        formValue?.patient_pincode || "";
      prescribeData[index]["patient_dob"] = formValue?.clientDOB
        ? moment(formValue?.clientDOB)
        : moment(new Date());
      prescribeData[index]["patient_gender"] = formValue?.clientGender || "";
      prescribeData[index]["doctor_phone"] = medicineMetaDocData?.phone || "";
      prescribeData[index]["doctor_street"] =
        medicineMetaDocData?.clientAddress?.street || "";
      prescribeData[index]["doctor_city"] =
        medicineMetaDocData?.clientAddress?.city || "";
      prescribeData[index]["doctor_houseno"] =
        medicineMetaDocData?.clientAddress?.house || "";
      prescribeData[index]["doctor_pincode"] =
        medicineMetaDocData?.clientAddress?.pincode || "";
    } else {
      delete prescribeData[index]["patient_street"];
      delete prescribeData[index]["patient_houseno"];
      delete prescribeData[index]["patient_city"];
      delete prescribeData[index]["patient_pincode"];
      delete prescribeData[index]["patient_dob"];
      delete prescribeData[index]["patient_gender"];
      delete prescribeData[index]["doctor_phone"];
      delete prescribeData[index]["doctor_street"];
      delete prescribeData[index]["doctor_city"];
      delete prescribeData[index]["doctor_houseno"];
      delete prescribeData[index]["doctor_pincode"];
    }

    setPrescriptionData(prescribeData);
  };

  const onDateChange = (value) => {
    if (value) {
      setValue(value);
      const isoDate = value.toISOString();
      // var today = new Date();
      // var birthDate = new Date(value);
      // var age_now = today.getFullYear() - birthDate.getFullYear();

      // var m = today.getMonth() - birthDate.getMonth();
      // if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      //   age_now--;
      // }
      setformValue({
        ...formValue,
        dob: isoDate,
        clientDOB: isoDate,
        age: "",
      });
    }
  };
  const getUserDataById = async (id, isManual) => {
    if (!id) return;

    try {
      const response = await authenticatedRequest({
        method: "get",
        url: `/doctor/getUserDataById/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { result, statusCode } = response.data;
      if (statusCode === 200 && result) {
        setIsManualType(false);

        const isoDate = result?.dob || "";
        const parsedDate = moment(isoDate);
        setValue(parsedDate);

        let passportValue = "";
        if (result && Object.hasOwn(result, "passportNumber")) {
          setIsPassport(result?.passportNumber);
          passportValue = result?.passportNumber;
        }

        // Consolidated data for formValue and apiData
        const commonData = {
          first_name: result?.firstName || "",
          last_name: result?.lastName || "",
          email: result?.email || "",
          phone: result?.phone || "",
          clientGender: result?.gender || "",
          dob: isoDate,
          age: "",
          clientDOB: parsedDate,
        };

        setformValue({
          ...formValue,
          ...commonData,
          patient_street: result?.clientAddress?.street || "",
          patient_houseno: result?.clientAddress?.house || "",
          patient_city: result?.clientAddress?.city || "",
          patient_pincode: result?.clientAddress?.pincode || "",
          id: id,
        });
        setApiData({
          ...apiData,
          ...commonData,
          isPassportNum: passportValue,
          id: result.id,
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      if (isManual) {
        setformValue({
          ...formValue,
          id: id,
          dob: "",
          patient_street: "",
          patient_houseno: "",
          patient_city: "",
          patient_pincode: "",
        });
      } else {
        setformValue({
          id: id,
          ...resetData,
          patient_street: "",
          patient_houseno: "",
          patient_city: "",
          patient_pincode: "",
        });
        setValue(null);
      }
      setApiData({
        ...resetData,
        isPassportNum: "",
        id: "",
      });
    }
  };

  const handleGetData = (id, isManualType) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    const timeout = setTimeout(() => {
      getUserDataById(id, isManualType);
    }, 700);

    setDebounceTimeout(timeout);
  };

  const handleValueReset = () => {
    if (!isManualType && !meetingDetail) {
      setformValue({
        id: formValue.id,
        ...resetData,
        patient_street: "",
        patient_houseno: "",
        patient_city: "",
        patient_pincode: "",
      });
      setValue(null);
      setApiData({
        ...resetData,
        isPassportNum: "",
        id: "",
      });
      setIsPassport(false);
    }
  };

  const handleMeetingReset = () => {
    if (followUp) {
      setFollowUp({});
      setformValue({
        id: formValue.id,
        ...resetData,
        patient_street: "",
        patient_houseno: "",
        patient_city: "",
        patient_pincode: "",
      });
      setConsultId("");
      setAllPdfDocument([]);
      setValue(null);
      navigate(location.pathname, { state: null });
    }
  };

  const handleChange = (event) => {
    const { name, value, checked } = event.target;
    let updatedValue = value;

    switch (name) {
      case "id":
        updatedValue = value.replace(/\s/g, "").toUpperCase();
        if (!isPassport && updatedValue.length > 9) {
          return;
        }

        if (isPassport) {
          handleGetData(updatedValue, isManualType);
        } else if (updatedValue.length === 9) {
          handleGetData(updatedValue, isManualType);
        }

        if (formValue.id) {
          if (updatedValue !== formValue.id) {
            handleValueReset();
          }
        }
        if (meetingDetail) {
          if (updatedValue !== meetingDetail.userDetails.id) {
            handleMeetingReset();
          }
        }

        break;

      case "first_name":
        updatedValue = value.replace(/\s/g, "");
        break;

      case "passportNumber":
        setIsPassport(!isPassport);
        setformValue((prev) => ({ ...prev, [name]: checked }));
        break;

      case "phone":
        if (!/^[0-9+ -]*$/.test(value)) {
          return;
        }
        break;

      default:
        break;
    }
    if (name !== "id") {
      setIsManualType(true);
    }
    setformValue((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };
  const handleChangeConsultId = (event) => {
    setConsultId(event.target.value);
  };

  useEffect(() => {
    let isValid = false;
    for (let key of Object.keys(summary)) {
      if (summary[key]) {
        isValid = true;
        break;
      }
    }
    setisNewValue(isValid);
  }, [summary]);
  useEffect(() => {
    if (selectedSec === -1) {
      return;
    } else {
      allMedicine(searchKey[selectedSec] || "a", selectedSec);
    }
  }, [props.meetingId, searchKey, selectedSec]);

  const handleinputchange = (e, index) => {
    setPrescriptionData((prevState) => {
      const updatedData = [...prevState];
      if (e.target) {
        const { name, value } = e.target;
        if (name === "chronic" || name === "usedOnRegularBasis") {
          const checked = e.target.checked;
          updatedData[index] = {
            ...updatedData[index],
            [name]: checked,
          };
        } else if (name === "doctor_phone" && /^[0-9+ -]*$/.test(value)) {
          updatedData[index] = {
            ...updatedData[index],
            [name]: value,
          };
        } else if (name === "remarks") {
          if (value?.length >= 200) {
            toast.error(t("Remarks cannot exceed 200 characters"), {
              toastId: "remarks",
            });
          }
          updatedData[index] = {
            ...updatedData[index],
            [name]: value,
          };
        } else if (name === "frequencyUnit") {
          const frequencyIndex = unitOrder.indexOf(value);
          const durationIndex = unitOrder.indexOf(
            updatedData[index].durationUnit
          );
          if (durationIndex !== -1 && frequencyIndex > durationIndex) {
            updatedData[index] = {
              ...updatedData[index],
              frequencyUnit: value,
              durationUnit: "", // Reset durationUnit if not valid anymore
            };
          } else {
            updatedData[index] = {
              ...updatedData[index],
              frequencyUnit: value,
            };
          }
        } else if (name === "dosage") {
          const finalValue = Number(value);
          updatedData[index] = {
            ...updatedData[index],
            [name]: finalValue,
          };
        } else {
          updatedData[index] = {
            ...updatedData[index],
            [name]: value,
          };
        }
      } else {
        updatedData[index] = {
          ...updatedData[index],
          medicineId: e._id,
          name: e.Name,
        };
      }

      return updatedData;
    });
  };

  const handleremove = (data, i) => {
    const updatedPrescriptionData = prescriptionData.filter((d) => d !== data);
    setPrescriptionData(updatedPrescriptionData);
    const updatedMedicMetaDetails = {};

    updatedPrescriptionData.forEach((item, index) => {
      updatedMedicMetaDetails[index] = item?.isSam;
    });
    setMedicMetaDetails(updatedMedicMetaDetails);
    setErrors({});
    setSearchKey((prev) => prev.filter((_, index) => index !== i));
    setMedicineList((prev) => prev.filter((_, index) => index !== i));
  };
  const handleaddclick = () => {
    setPrescriptionData([
      ...prescriptionData,
      {
        medicineId: "",
        name: "",
        quantity: "",
        frequency: "",
        frequencyUnit: "",
        duration: "",
        durationUnit: "",
        dosage: "",
        remarks: "",
        chronic: false,
        usedOnRegularBasis: false,
      },
    ]);
    setMedicineValue({});
  };

  const allMedicine = async (data, index) => {
    if (data) {
      try {
        const response = await authenticatedRequest({
          method: "get",
          url: `/doctor/medications/${data}`,
          headers: {
            "Content-Type": "application/json",
          },
        });

        setMedicineList((prev) => {
          const newMedicineLists = [...prev];
          newMedicineLists[index] = response.data.medication;
          return newMedicineLists;
        });
      } catch (error) {
        console.log(error);
      }
    }
  };
  const userDetails = async () => {
    const data = {
      userId: userId,
    };
    await userGetUserProfile(data).then((response) => {
      if (response) {
        let result = response?.data?.profileDetails[0];
        if (result !== undefined && result !== null) {
          setMedicineMetaDocData(result);
          setDoctorData(result?.doctorData[0]);
          if (result.prescriptionFields && result.prescriptionFields[0]) {
            setAddField({
              fieldName: result?.prescriptionFields[0].label,
              fieldPosition: result?.prescriptionFields[0].order,
              fieldPermanentStatus:
                result?.prescriptionFields[0].fieldPermanentStatus,
            });
            setAdditionalData(result.prescriptionFields[0]);
            handleProfileFieldData(result.prescriptionFields[0]);
          }
          let consultingFieldsArr =
            result?.doctorData[0]?.consultationSpeciality;
          setConsultField(consultingFieldsArr);
        }
      }
    });
  };

  const doctorDataById = async (docId) => {
    try {
      const response = await axios.get(
        `${serverPath}/users/getDoctorsById/${docId}`
      );

      const {
        data: { statusCode, doctor },
      } = response || {};
      if (statusCode === 200) {
        setDoctorObj(doctor[0]);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    doctorDataById(userId);
    if (userId) {
      userDetails();
    }
  }, [userId]);

  useEffect(() => {
    if (meetingDetail) {
      setConsultId(meetingDetail?.consultingFieldId);
    } else if (
      doctorData?.consultationSpeciality &&
      doctorData?.consultationSpeciality.length === 1
    ) {
      setConsultId(doctorObj?.consultationSpeciality[0]);
    }
  }, [doctorData, meetingDetail, doctorObj]);

  let isValid;
  const validation = () => {
    isValid = true;
    const errorObj = {};
    let toastShown = false; // Flag to indicate if a toast has already been shown

    prescriptionData.forEach((d, index) => {
      if (!errorObj[index]) {
        errorObj[index] = [];
      }

      const showToast = (message, id) => {
        if (!toastShown) {
          toast.error(t(message), {
            toastId: id,
          });

          toastShown = true;
        }
      };

      if (!d.name) {
        showToast(t("Medicine name is mandatory field", d.name));
        errorObj[index].push("name");
        isValid = false;
      }
      if (!d.quantity) {
        showToast(t("Quantity is mandatory field", d.quantity));
        errorObj[index].push("quantity");
        isValid = false;
      }
      let medicMetaDetailsError = false;
      if (medicMetaDetails[index]) {
        if (!d.patient_street) {
          //showToast("Patient street address is a mandatory field");
          errorObj[index].push("patient_street");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.patient_houseno) {
          //showToast("Patient house no is a mandatory field");
          errorObj[index].push("patient_houseno");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.patient_city) {
          //showToast("Patient city is a mandatory field");
          errorObj[index].push("patient_city");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.patient_pincode) {
          //showToast("Patient pincode is a mandatory field");
          errorObj[index].push("patient_pincode");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.patient_dob) {
          //showToast("Patient DOB is a mandatory field");
          errorObj[index].push("patient_dob");
          isValid = false;
          medicMetaDetailsError = true;
        }
        // if (!d.patient_gender) {
        //   //showToast("Patient Gender is a mandatory field");
        //   errorObj[index].push("patient_gender");
        //   isValid = false;
        //   medicMetaDetailsError = true;
        // }
        if (!d.doctor_phone) {
          //showToast("Clinic phone no is a mandatory field");
          errorObj[index].push("doctor_phone");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.doctor_street) {
          //showToast("Doctor street is a mandatory field");
          errorObj[index].push("doctor_street");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.doctor_houseno) {
          //showToast("Doctor house no is a mandatory field");
          errorObj[index].push("doctor_houseno");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.doctor_city) {
          //showToast("Doctor city is a mandatory field");
          errorObj[index].push("doctor_city");
          isValid = false;
          medicMetaDetailsError = true;
        }
        if (!d.doctor_pincode) {
          //showToast("Doctor pincode is a mandatory field");
          errorObj[index].push("doctor_pincode");
          isValid = false;
          medicMetaDetailsError = true;
        }
      }
      if (!d.dosage) {
        showToast(t("Dosage is a mandatory field", d.dosage));
        errorObj[index].push("dosage");
        isValid = false;
      }
      if (!d.frequency) {
        showToast(t("Times is mandatory field", d.frequency));
        errorObj[index].push("frequency");
        isValid = false;
      }
      if (!d.frequencyUnit) {
        showToast(t("Frequency is mandatory field", d.frequencyUnit));
        errorObj[index].push("frequencyUnit");
        isValid = false;
      }
      if (!d.duration) {
        showToast(t("Period is mandatory field", d.duration));
        errorObj[index].push("duration");
        isValid = false;
      }
      if (!d.durationUnit) {
        showToast(t("Duration is mandatory field", d.durationUnit));
        errorObj[index].push("durationUnit");
        isValid = false;
      }
      if (medicMetaDetailsError) {
        showToast(t("Please fill the mendatory fields"), "medic");
      }
      if (medicMetaDetails[index]) {
        if (!summary.diagnsis && isValid) {
          showToast(
            t(
              "Please note: A diagnosis must be entered when prescribing a narcotic",
              summary.diagnsis
            )
          );
          setKey("Summary");
          setDiagonosisError(true);
          isValid = false;
        }
      }
    });

    return { isValid, errorObj };
  };

  let isValidate;

  const validate = () => {
    isValidate = true;
    if (!formValue.id) {
      isValidate = false;
      toast.error(t("Please enter id number"));
      return;
    }
    if (!isPassport) {
      const isValidId = validateIsraeliID(formValue.id);

      if (!isValidId) {
        isValidate = false;
        toast.error(t("The ID number you entered is invalid"));
        return;
      }
    }

    if (!isPassport && formValue.id.length < 9) {
      isValidate = false;
      toast.error(t("Please enter full ID number"));
    }
    if (!formValue.first_name) {
      isValidate = false;
      toast.error(t("Please enter first name"));
      return;
    }
    if (!formValue.last_name) {
      isValidate = false;
      toast.error(t("Please enter last name"));
      return;
    }
    if (formValue?.email) {
      const isEmailCorrect = checkEmailFormate(formValue?.email);
      if (!isEmailCorrect) {
        isValidate = false;
        toast.error("Please enter valid email");
        return;
      }
    }

    // if (!formValue.email) {
    //   isValidate = false;
    //   toast.warning(t("Please enter email address"));
    //   return;
    // }

    // if (typeof formValue.email !== "undefined") {
    //   const pattern = new RegExp(
    //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    //   );
    //   if (!pattern.test(formValue.email)) {
    //     isValidate = false;
    //     toast.warning(t("Please enter valid email"));
    //     return;
    //   }
    // }
    if (!formValue.phone) {
      isValidate = false;

      toast.error(t("Please enter mobile number"));
      return;
    }
    if (formValue.phone) {
      if (formValue.phone.length > 20) {
        isValidate = false;

        toast.error(t("Mobile number max length 20"));
        return;
      }
      if (
        !formValue.phone.startsWith("05") &&
        !formValue.phone.startsWith("+")
      ) {
        isValidate = false;
        toast.error("Phone number must start with 05 or +.");
        return;
      }
      // const parsedNumber = phoneUtil.parse(formValue.phone, "IL");
      // if (!phoneUtil.isPossibleNumber(parsedNumber)) {
      //   isValidate = false;
      //   toast.error("Invalid phone number format.");
      //   return;
      // }
      try {
        const parsedNumber = phoneUtil.parse(formValue.phone, "IL");
        if (!phoneUtil.isValidNumber(parsedNumber)) {
          isValidate = false;
          toast.error("Invalid phone number.");
          return;
        }
      } catch (err) {
        isValidate = false;
        toast.error("Invalid phone number.");
        return;
      }
    }
    if (!value) {
      isValidate = false;
      toast.error(t("Please choose date of birth"));
      return;
    }
    if (!value._isValid) {
      isValidate = false;
      toast.error(t("Please fill correct date of birth"));
      return;
    }

    if (!consultId) {
      isValidate = false;
      toast.error(t("Please select consultation field"));
      return;
    }
    if (medicMetaDetails && Object.keys(medicMetaDetails).length > 0) {
      if (!formValue.clientGender) {
        isValidate = false;
        toast.error(t("Patient Gender is a mandatory field"));
        return;
      }
    }

    return isValidate;
  };
  const handleSummarychange = (e, key) => {
    const { value } = e.target;
    if (key === "diagnsis") {
      if (value?.length >= 250) {
        toast.error(t("Diagnosis cannot exceed 250 characters"), {
          toastId: "diagnsis",
        });
      }
    }
    setSummary({ ...summary, [key]: value });
    if (value === "#") {
      handleFilteredTemp(key);
      setTargetInput(key);
    }
    if (rxMeetingId) {
      typing = true;
    }
  };

  const uploadSummary = async (e) => {
    e.preventDefault();
    const removeProperties = (obj, propsToRemove) => {
      const newObj = { ...obj };
      propsToRemove.forEach((prop) => delete newObj[prop]);
      return newObj;
    };

    // Exclude these properties from formValue
    const excludedProperties = [
      "patient_street",
      "patient_houseno",
      "patient_city",
      "patient_pincode",
    ];

    const updatedFormValue = removeProperties(formValue, excludedProperties);

    let data = {
      requestDescription: "",
      service: "video",
      consultingFieldId: consultId,
      isUrgent: false,
      termsAndConditions: true,
      age: "",
      issueInvoice: false,
      ...updatedFormValue,
      refferalId: "",
      ...summary,
      prescription: prescriptionData,
      continuingCare: "",
      passportNumber: isPassport,
    };
    let newFieldValue;
    if (addField.fieldName && addField.fieldPermanentStatus) {
      const summaryKeys = Object.keys(summary);
      if (summaryKeys.includes(addField.fieldName)) {
        newFieldValue = summary[addField.fieldName];
      }
      data.prescriptionFields = {
        name: addField.fieldName,
        position: addField.fieldPosition,
        data: newFieldValue ? newFieldValue : "",
      };
    }
    validate();
    const { isValid, errorObj } = validation();
    if (!isValid) {
      setErrors(errorObj);
      return;
    }
    setPayloadData(data);
    return data
  };

  const signandsend = async (e) => {
    const data = await uploadSummary(e);
    if (isValid === true && isValidate === true) {
      if (doctorData.signatureCredentials) {
        await handleFinishSend(data);
      } else {
        setGenerateupdateModal(true);
      }
    }
  };

  const handleFinishSend = async (payload) => {
    const data = {};
    setIsLoader(true);
    try {
      let response = null;
      let dataPayload = {};

      if (rxMeetingId) {
        // generatePDF API Calls
        data.meetingId = rxMeetingId;
        response = await doctorGeneratePdf(data);
        toast.success(t(response.data.msg));
        localStorage.setItem("status", "Rx");
        navigate("/Queues");
        setRxMeetingId("");
      } else if (payload) {
        // Create prescription with additional payload data
        dataPayload = { ...data, ...payload };
        const response = await doctorCreatePrescription(dataPayload);
        toast.success(t(response.data.message));
        localStorage.setItem("status", "Rx");
        navigate("/Queues");
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
      typeof setRxMeetingId === "function" &&
        setRxMeetingId(error?.response?.data?.meetingId);
      Swal.fire({
        icon: "error",
        title: t("Error"),
        text: t(error?.response?.data?.message || error.message),
        allowOutsideClick: false,
        customClass: {
          popup: "swal2-front",
          htmlContainer: "my-swal-text",
          confirmButton: "my-swal-button",
        },
      });
    }
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      let element = document.querySelector(".red-border");
      if (element) {
        element?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
      setTimeout(() => {
        setErrors({});
      }, 20000);
    }
  }, [Object.keys(errors).length > 0]);

  const searchMedicine = (event, index) => {
    const isMobileDevice = isMobile();
    // Don't process Ctrl, Alt, or Meta alone
    if (
      (event.ctrlKey || event.altKey || event.metaKey) &&
      event.code !== "Backspace"
    ) {
      return;
    }

    setSearchKey((prev) => {
      const newSearchKeys = [...prev];
      const currentValue = newSearchKeys[index] || "";
      const input = event.target;

      // Get cursor positions
      const start = input.selectionStart;
      const end = input.selectionEnd;

      // Check if all text is selected
      const allTextSelected = start === 0 && end === currentValue.length;

      // CASE 1: All text selected and a key is pressed (replace the value)
      if (allTextSelected && event.code?.startsWith("Key") && !event.ctrlKey) {
        newSearchKeys[index] = event.code.replace("Key", "").toUpperCase();
      }
      // CASE 2: Ctrl+A + Backspace or all text selected + Backspace
      else if (
        event.code === "Backspace" &&
        (allTextSelected || event.ctrlKey)
      ) {
        newSearchKeys[index] = "";
      }
      // CASE 3: Backspace with selected text
      else if (event.code === "Backspace" && start !== end) {
        newSearchKeys[index] =
          currentValue.slice(0, start) + currentValue.slice(end);
      }
      // CASE 4: Regular Backspace at cursor position
      else if (event.code === "Backspace") {
        if (start > 0) {
          newSearchKeys[index] =
            currentValue.slice(0, start - 1) + currentValue.slice(start);
        }
      }
      // CASE 5: Regular key press (append at cursor position)
      else if (event.code?.startsWith("Key") && !allTextSelected) {
        const letter = event.code.replace("Key", "").toUpperCase();
        newSearchKeys[index] =
          currentValue.slice(0, start) + letter + currentValue.slice(end);
      }
      if (isMobileDevice) {
        newSearchKeys[index] = event.target.value.toUpperCase();
      }

      return newSearchKeys;
    });
  };

  const handleListModal = (index) => {
    setSelectedSec(index);
  };

  const handleTemplateChange = (event) => {
    const { name, value } = event.target;
    setAddTemplate({
      ...addTemplate,
      [name]: value,
    });
  };
  const handleMultiChange = (value) => {
    setAddTemplate({
      ...addTemplate,
      ["templateField"]: value,
    });
  };

  let isTemplateValidate;

  const templateValidation = () => {
    isTemplateValidate = true;
    if (!addTemplate.templateName) {
      isTemplateValidate = false;
      toast.warning(t("Please enter template name"));
      return;
    }
    if (!addTemplate.templateText) {
      isTemplateValidate = false;
      toast.warning(t("Please enter template text"));
      return;
    }
    if (addTemplate.templateField.length === 0) {
      isTemplateValidate = false;
      toast.warning(t("Please select field name"));
      return;
    }
    return isTemplateValidate;
  };

  const handleTemplateSubmit = async () => {
    const templateFieldArray = addTemplate.templateField.map(
      (item) => item.value
    );

    const data = {
      templateName: addTemplate.templateName,
      templateText: addTemplate.templateText,
      templateField: templateFieldArray,
    };

    const isValid = templateValidation();

    if (isValid) {
      try {
        const response = await doctorSaveTemplate(data);
        const { code, message } = response.data;
        if (code === 201) {
          toast.success(t(message));
          setShowTemplateModal(false);
          getTemplateList();
          setAddTemplate({
            templateName: "",
            templateText: "",
            templateField: [],
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getTemplateList = async () => {
    try {
      const response = await doctorGetTemplate();
      const { code, templates } = response.data;
      if (code === 200) {
        setTemplateList(templates);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTemplateList();
  }, []);

  const handleEditTemplate = (data) => {
    setIsEditTemp(true);
    setTemplateId(data._id);
    const valuesArray = data.templateField;
    const filterTemplateField = valuesArray.map((value) => {
      const initialField = initialFieldArray.find(
        (item) => item.value === value
      );
      if (initialField) {
        return { value, label: initialField.label };
      } else {
        return { value, label: value };
      }
    });

    setAddTemplate({
      templateName: data.templateName,
      templateText: data.templateText,
      templateField: filterTemplateField,
    });
  };

  const submitEditTemplate = async () => {
    const templateFieldArray = addTemplate.templateField.map(
      (item) => item.value
    );

    const data = {
      templateId: templateId,
      templateName: addTemplate.templateName,
      templateText: addTemplate.templateText,
      templateField: templateFieldArray,
    };

    const isValid = templateValidation();

    if (isValid) {
      try {
        const response = await doctorUpdateTemplate(data);
        const { code, message } = response.data;
        if (code === 201) {
          toast.success(t(message));
          setIsEditTemp(false);
          getTemplateList();
          setTemplateId("");
          setAddTemplate({
            templateName: "",
            templateText: "",
            templateField: [],
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleCloseTempModal = () => {
    setIsEditTemp(false);
    setTemplateId("");
    setShowTemplateModal(false);
    setAddTemplate({
      templateName: "",
      templateText: "",
      templateField: [],
    });
  };

  const handleDeleteTemplate = async () => {
    try {
      const response = await authenticatedRequest({
        method: "delete",
        url: `/doctor/deleteTemplate/${templateId}`,
        headers: {
          "Content-Type": "application/json",
        },
      });

      const { code, message } = response.data;
      if (code === 201) {
        getTemplateList();
        toast.success(t(message));
        setDeleteTempModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFilteredTemp = (key) => {
    if (key) {
      const filteredTemplate = templateList.filter((item) =>
        item.templateField?.includes(key)
      );
      setFilteredTemplate(filteredTemplate);
      setShowSearch(true);
    }
  };

  const handleSelectTemp = (data) => {
    setSummary({ ...summary, [targetInput]: data.templateText });
    setShowSearch(false);
  };

  const handleAddTemplate = () => {
    setAddTemplate({
      templateName: "",
      templateText: "",
      templateField: [],
    });
    setIsEditTemp(false);
    setTemplateId("");
  };

  const handleCloseDeleteTemplate = () => {
    if (!isEditTemp) {
      setTemplateId("");
    }
    setDeleteTempModal(false);
  };

  const handleFieldModal = () => {
    setShowFieldModal(true);
  };
  const handleCloseFieldModal = () => {
    setShowFieldModal(false);
  };

  const handleFieldSubmit = async () => {
    const fieldStatus =
      addField.fieldPermanentStatus === "true" ||
      addField.fieldPermanentStatus === true;
    const data = {
      prescriptionFields: {
        label: addField.fieldName,
        fieldPermanentStatus: fieldStatus,
        order: parseInt(addField.fieldPosition),
      },
    };

    const isFieldValid = fieldValidation();

    if (isFieldValid && fieldStatus) {
      try {
        const response = await doctorSetPrescriptionSettings(data);
        const { code } = response.data;
        if (code === 200) {
          userDetails();
          setShowFieldModal(false);
        }
      } catch (error) {
        console.log(error);
      }
    } else if (isFieldValid) {
      setShowFieldModal(false);
      handleProfileFieldData(data.prescriptionFields);
      if (additionalData.fieldPermanentStatus) {
        deletePrescriptionSetting(false);
        setAdditionalData({});
      }
    }
  };

  const handleProfileFieldData = (data) => {
    const newField = {
      name: data.label,
      value: data.label,
      label: data.label,
    };
    const newPosition = parseInt(data.order);
    const insertIndex = newPosition - 1;
    let copySummary = JSON.parse(JSON.stringify(initialFieldArray));

    setSummaryFieldArray([
      ...copySummary.slice(0, insertIndex),
      newField,
      ...copySummary.slice(insertIndex),
    ]);
  };

  const removeProfileFieldData = (indexToRemove) => {
    if (indexToRemove) {
      const removePosition = parseInt(indexToRemove) - 1;
      setSummaryFieldArray((prevSummaryFieldArray) => {
        const copySummary = JSON.parse(JSON.stringify(prevSummaryFieldArray));
        copySummary.splice(removePosition, 1);
        return copySummary;
      });
      setAddField({
        fieldName: "",
        fieldPosition: "",
        fieldPermanentStatus: "",
      });
    }
  };

  const deletePrescriptionSetting = async (isRemove) => {
    try {
      const response = await authenticatedRequest({
        method: "delete",
        url: `/doctor/deleteUserPrescriptionFields`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if ([200].includes(response.status) && isRemove) {
        removeProfileFieldData(addField.fieldPosition);
        setShowFieldModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddFieldChange = (event) => {
    const { name, value } = event.target;
    setAddField({
      ...addField,
      [name]: value,
    });
  };

  let isFieldValidate;

  const fieldValidation = () => {
    isFieldValidate = true;
    if (!addField.fieldName) {
      isFieldValidate = false;
      toast.warning(t("Please enter field name"));
      return;
    }
    if (!addField.fieldPosition && addField.fieldPosition === "") {
      isFieldValidate = false;
      toast.warning(t("Please select field position"));
      return;
    }
    if (addField.fieldPermanentStatus === "") {
      isFieldValidate = false;
      toast.warning(t("Please select field permanently"));
      return;
    }
    return isFieldValidate;
  };

  const CustomToolTip = ({ id, children, title }) => (
    <OverlayTrigger
      // delay={{ hide: 40000 }}
      overlay={
        <Tooltip id={id} className="prescription-tooltip">
          {title}
        </Tooltip>
      }
    >
      <span className="tooltip-circle">{children}</span>
    </OverlayTrigger>
  );

  const handleDocModel = (index) => {
    setOpenModel(!openModel);
    setDocIndex(index);
    if (!openModel) {
      viewPdf(allPdfDocument[index]?.path, allPdfDocument[index]?.fileType);
    } else {
      setDocURL("");
    }
  };

  const handlePreDoc = () => {
    viewPdf(
      allPdfDocument[docIndex - 1].path,
      allPdfDocument[docIndex - 1]?.fileType
    );
    setDocIndex(docIndex - 1);
  };
  const handleNextDoc = () => {
    viewPdf(
      allPdfDocument[docIndex + 1].path,
      allPdfDocument[docIndex + 1]?.fileType
    );
    setDocIndex(docIndex + 1);
  };
  const viewPdf = async (path, type) => {
    setLoading(true);
    const data = {
      url: path,
    };

    const response = await documentView(data);
    setDocURL({ view: response.data, original: path, type: type });
    setLoading(false);
  };

  useEffect(() => {
    if (diagonosisError) {
      let element = document.querySelector(".error-color");
      if (element) {
        element?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
      setTimeout(() => {
        setDiagonosisError(false);
      }, 5000);
    }
  }, [diagonosisError]);

  $("#rsd__select-day option:first-child").text(t("Day"));
  $("#rsd__select-month option:first-child").text(t("Month"));
  $("#rsd__select-year option:first-child").text(t("Year"));

  return (
    <>
      <GeneratePdf
        generateUpdateModal={generateUpdateModal}
        handleClose4={handleClose4}
        meetingId={props.meetingId}
        handleClose={props.handleClose}
        payloadData={payloadData}
        typing={typing}
        rxMeetingId={rxMeetingId}
        setRxMeetingId={setRxMeetingId}
      />
      {showTemplateModal ? (
        <AddTemplateModal
          showTemplateModal={showTemplateModal}
          handleTemplateChange={handleTemplateChange}
          addTemplate={addTemplate}
          handleTemplateSubmit={handleTemplateSubmit}
          handleMultiChange={handleMultiChange}
          templateList={templateList}
          handleEditTemplate={handleEditTemplate}
          summaryFieldArray={summaryFieldArray}
          isEditTemp={isEditTemp}
          submitEditTemplate={submitEditTemplate}
          setTemplateId={setTemplateId}
          setDeleteTempModal={setDeleteTempModal}
          deleteTempModal={deleteTempModal}
          handleCloseTempModal={handleCloseTempModal}
          handleAddTemplate={handleAddTemplate}
          templateId={templateId}
        />
      ) : null}

      {deleteTempModal ? (
        <DeleteTemplateModal
          deleteTempModal={deleteTempModal}
          setDeleteTempModal={setDeleteTempModal}
          handleDeleteTemplate={handleDeleteTemplate}
          handleCloseDeleteTemplate={handleCloseDeleteTemplate}
        />
      ) : null}

      {showSearch && (
        <TemplateSearchList
          filteredTemplate={filteredTemplate}
          handleSelectTemp={handleSelectTemp}
          showSearch={showSearch}
          setShowSearch={setShowSearch}
        />
      )}

      {showFieldModal ? (
        <AddFieldModal
          showFieldModal={showFieldModal}
          handleCloseFieldModal={handleCloseFieldModal}
          handleAddFieldChange={handleAddFieldChange}
          addField={addField}
          handleFieldSubmit={handleFieldSubmit}
          setDeleteFieldModal={setDeleteFieldModal}
          summaryFieldArray={summaryFieldArray}
          deleteFieldModal={deleteFieldModal}
        />
      ) : null}
      {deleteFieldModal ? (
        <DeleteFieldModal
          deleteFieldModal={deleteFieldModal}
          setDeleteFieldModal={setDeleteFieldModal}
          deletePrescriptionSetting={deletePrescriptionSetting}
          additionalFieldData={addField}
          removeProfileFieldData={removeProfileFieldData}
          setShowFieldModal={setShowFieldModal}
        />
      ) : null}

      {openModel ? (
        <AllDocumentModel
          openModel={openModel}
          handleClose={handleDocModel}
          docURL={docURL}
          handlePreDoc={handlePreDoc}
          handleNextDoc={handleNextDoc}
          documentLength={allPdfDocument?.length}
          docIndex={docIndex}
          loading={loading}
        />
      ) : null}
      <div className="user-create-section">
        <Form>
          <div
            className={`${"confirmation-agree-section"} ${lang === "EN" ? "textleft" : "textright"
              }`}
          >
            <>
              <div className="confirmation-input-section">
                <Form.Group className="form-group">
                  <Form.Label className={`id-label ${isPassport}`}>
                    {" "}
                    <p className={` ${isPassport ? "label-active" : ""}`}>
                      {" "}
                      {t("Id Number")}
                    </p>
                    <div
                      class={`slideThree ${apiData?.id ? "disable-check" : ""
                        }  ${isPassport} ${lang}`}
                      data-translation={
                        !isPassport ? t("Passport") : t("Id Number")
                      }
                      disabled={apiData?.id}
                    >
                      <input
                        type="checkbox"
                        value="None"
                        id="slideThree"
                        name="passportNumber"
                        checked={isPassport}
                        onChange={handleChange}
                        disabled={apiData?.id}
                      />
                      <label
                        for="slideThree"
                        style={{
                          cursor: apiData?.id ? "not-allowed" : "pointer",
                        }}
                      ></label>
                    </div>
                    <p className={`${!isPassport ? "label-active" : ""}`}>
                      {" "}
                      {t("Passport")}
                    </p>
                  </Form.Label>
                  <Form.Control
                    name="id"
                    type={isPassport ? t("text") : t("number")}
                    onChange={handleChange}
                    id="id"
                    placeholder={isPassport ? t("Passport") : t("Id Number")}
                    value={formValue.id}
                    maxLength={!isPassport ? 9 : undefined}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("First Name")} </Form.Label>
                  <Form.Control
                    name="first_name"
                    type="text"
                    onChange={handleChange}
                    id="first_name"
                    placeholder={t("First Name")}
                    value={formValue.first_name}
                    disabled={apiData?.first_name || followUp?.first_name}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Last Name")}</Form.Label>
                  <Form.Control
                    name="last_name"
                    type="text"
                    onChange={handleChange}
                    id="last_name"
                    placeholder={t("Last Name")}
                    value={formValue.last_name}
                    disabled={apiData?.last_name || followUp?.last_name}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Email")} </Form.Label>
                  <Form.Control
                    name="email"
                    type="text"
                    onChange={handleChange}
                    id="email"
                    placeholder={t("Email")}
                    value={formValue.email}
                    disabled={apiData?.email || followUp.email}
                  />
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label>
                    {" "}
                    {t("Phone Number")}{" "}
                    <CustomToolTip
                      title={t(
                        "An Israeli phone number should start with 05. For a foreign number, please start with + and enter the full number with the country code."
                      )}
                      id="phoneNumber"
                    >
                      {" "}
                      ?{" "}
                    </CustomToolTip>
                  </Form.Label>
                  <Form.Control
                    name="phone"
                    type="text"
                    onChange={handleChange}
                    id="phone"
                    className="phone_number"
                    placeholder={t("Phone Number")}
                    value={formValue.phone}
                    pattern="[+0-9 \-]+"
                    disabled={apiData?.phone || followUp?.phone}
                  />
                </Form.Group>

                <Form.Group className="form-group">
                  <Form.Label> {t("Gender")}</Form.Label>
                  <div className="choose-gender-grid">
                    <Form.Check
                      type={"radio"}
                      label={t("Male")}
                      name="clientGender"
                      value="Male"
                      onChange={handleChange}
                      checked={formValue.clientGender === "Male"}
                      disabled={apiData?.clientGender || followUp?.clientGender}
                    />
                    <Form.Check
                      type={"radio"}
                      label={t("Female")}
                      name="clientGender"
                      value="Female"
                      onChange={handleChange}
                      checked={formValue.clientGender === "Female"}
                      disabled={apiData?.clientGender || followUp?.clientGender}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="form-group">
                  <Form.Label> {t("Date of Birth")} </Form.Label>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DatePicker
                      slotProps={{
                        field: {
                          clearable: true,
                          onClear: () => setCleared(true),
                        },
                      }}
                      views={["year", "month", "day"]}
                      onChange={onDateChange}
                      value={value}
                      disableFuture
                      format="DD/MM/YYYY"
                      inputFormat="DD/MM/YYYY"
                      className="rx-dob"
                      // openTo="year"
                      disabled={apiData?.dob || followUp?.clientDOB}
                    />
                  </LocalizationProvider>
                </Form.Group>
                {doctorData?.consultationSpeciality &&
                  doctorData?.consultationSpeciality.length > 1 ? (
                  <Form.Group>
                    <Form.Label> {t("Choose Consultation field")} </Form.Label>
                    <Form.Select
                      name="consultId"
                      onChange={handleChangeConsultId}
                      aria-label="Default select example"
                      disabled={meetingDetail?.consultingFieldId}
                      className={`${meetingDetail ? "disable-select" : ""}`}
                    >
                      <option value="">{t("Select")}</option>
                      {consultField &&
                        consultField
                          .filter(
                            (item) =>
                              item?.meetingGroupId !==
                              "640ed7103f08dcee2d1f1719"
                          )
                          .map((el) => (
                            <option
                              value={el?._id}
                              key={el?._id}
                              selected={el?._id === consultId}
                            >
                              {lang === "HE" ? el?.heb : el?.eng}
                            </option>
                          ))}
                    </Form.Select>
                  </Form.Group>
                ) : null}
              </div>
            </>
          </div>
        </Form>
      </div>
      {allPdfDocument?.length > 0 && (
        <div className="summaries-list-section">
          <h3 style={{ textAlign: "center" }}>{t("Earlier summaries")} </h3>
          <ul className="listdocument">
            {allPdfDocument
              ? allPdfDocument.map((fileName, i) => {
                return (
                  <li key={i}>
                    <div className="row fileList">
                      <div className="col-md-6">
                        <p className="file-name">
                          {fileName?.type === "Summary"
                            ? `${t("Meeting summary from") +
                            moment(fileName?.createdAt).format(
                              "DD.MM.YYYY"
                            )
                            }`
                            : fileName.name}
                        </p>
                      </div>
                      <div className="col-md-3">
                        <div className="file-thumbnail">
                          <img
                            src={
                              fileName?.fileType === "pdf" ||
                                fileName?.fileType === "application/pdf"
                                ? pdfIcon
                                : imageIcon
                            }
                            alt="thumbnail"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <Button
                          className="view-doc-pdf"
                          onClick={() => handleDocModel(i)}
                        >
                          {t("View")}
                        </Button>
                      </div>
                    </div>
                  </li>
                );
              })
              : null}
          </ul>
        </div>
      )}
      <div className="inner-summary">
        <>
          {key == "Summary" ? (
            <>
              <div className="toggleDiv">
                <div className="tab-grid">
                  <span
                    onClick={() => {
                      setKey("Summary");
                    }}
                    className={key == "Summary" ? "spanActive" : "toggle "}
                  >
                    {t("Summary")}
                  </span>
                  <span
                    onClick={() => {
                      setKey("Prescription");
                    }}
                    className={key == "Prescription" ? "spanActive" : "toggle "}
                  >
                    {t("Prescription")}
                  </span>
                </div>
              </div>
              <div className="add-template-btn">
                <Button onClick={() => setShowTemplateModal(true)}>
                  {t("Templates settings")}
                </Button>{" "}
                <CustomToolTip
                  title={t(
                    "To retrieve the template press # in the relevant field, the list of templates you have defined for that field will appear"
                  )}
                  id="templateSetting"
                >
                  {" "}
                  ?{" "}
                </CustomToolTip>
              </div>
              <Form className="summarytext">
                {summaryFieldArray.map((field, i) => {
                  return (
                    <Form.Group
                      key={i}
                      className={
                        addField.fieldName === field.name &&
                          addField.fieldPermanentStatus === false
                          ? "hide-field"
                          : ""
                      }
                    >
                      <h3>{field?.label}</h3>
                      <textarea
                        type="text"
                        rows={3}
                        onChange={(e) =>
                          handleSummarychange(e, `${field?.name}`)
                        }
                        value={summary[field?.name]}
                        placeholder={field?.label}
                        className={`form-control summary_text ${field?.name === "diagnsis" && diagonosisError
                            ? "error-color"
                            : ""
                          }`}
                        maxLength={field?.name === "diagnsis" && 250}
                      />
                      {field?.name === "diagnsis" && (
                        <p>{summary[field?.name]?.length || "0"}/250</p>
                      )}
                    </Form.Group>
                  );
                })}

                {props.checkIDF &&
                  props.checkIDF === "640ed7103f08dcee2d1f1719" ? (
                  <Form.Group className="frequency">
                    <h3> {t("Continuing Care")}</h3>
                    <select
                      className="form-control"
                      name="continuingCare"
                      onChange={(e) => handleSummarychange(e, "continuingCare")}
                      autoComplete="off"
                    >
                      <option value="">{t("Select")}</option>

                      {continuingCare.map((d, i) => {
                        return (
                          <option
                            key={i + 1}
                            value={d}
                            selected={
                              summary?.continuingCare?.trim() === d.trim()
                            }
                          >
                            {d}
                          </option>
                        );
                      })}
                    </select>
                  </Form.Group>
                ) : null}
              </Form>
            </>
          ) : (
            <>
              <div className="toggleDiv">
                <div className="tab-grid">
                  <span
                    onClick={() => {
                      setKey("Summary");
                    }}
                    className={key == "Summary" ? "spanActive" : "toggle "}
                  >
                    {t("Summary")}
                  </span>
                  <span
                    onClick={() => {
                      setKey("Prescription");
                    }}
                    className={key == "Prescription" ? "spanActive" : "toggle "}
                  >
                    {t("Prescription")}
                  </span>
                </div>
              </div>
              <Form className="form_sammary_press">
                {prescriptionData.length != 0 ? (
                  prescriptionData.map((data, i) => {
                    return (
                      <div className="form_sammary_field" key={i}>
                        <h2> {t("Update prescription")}</h2>
                        <div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                            className="medicine-row"
                          >
                            <Form.Group className="frequency medicine-select">
                              <Form.Label> {t("Medicine Name")}</Form.Label>
                              <div ref={(el) => (wrapperRef.current[i] = el)}>
                                <Form.Control
                                  type="text"
                                  name="medcineList"
                                  placeholder="Select"
                                  onChange={(e) => {
                                    handleMedicine(
                                      e.target.value,
                                      "inputVal",
                                      i
                                    );
                                  }}
                                  onKeyDown={(e) => searchMedicine(e, i)}
                                  onFocus={() => handleListModal(i)}
                                  value={data?.name}
                                  className={`${errors[i]?.indexOf("name") > -1
                                      ? "red-border"
                                      : ""
                                    }`}
                                  autoComplete="off"
                                />
                                {i === selectedSec &&
                                  medicineList[i] &&
                                  medicineList[i].length ? (
                                  <ul className="auto-complete">
                                    {medicineList[i].map((el) => (
                                      <li
                                        className="auto-complete-list"
                                        value={el.name}
                                        key={el._id}
                                        onClick={() =>
                                          handleMedicine(el, "listVal", i)
                                        }
                                        name="subcategory"
                                      >
                                        {el.Name}
                                      </li>
                                    ))}
                                  </ul>
                                ) : medicineList[i] &&
                                  !medicineList[i].length ? (
                                  <ul className="auto-complete">
                                    <li>No Results Found</li>
                                  </ul>
                                ) : null}
                              </div>
                            </Form.Group>
                            <Form.Group className="frequency">
                              <Form.Label>
                                {" "}
                                {t("Quantity")}{" "}
                                <CustomToolTip
                                  title={t(
                                    "Quantity: the number of packs of the medicine"
                                  )}
                                  id="quantity"
                                >
                                  {" "}
                                  ?{" "}
                                </CustomToolTip>{" "}
                              </Form.Label>

                              <Select
                                className={` ${errors[i]?.indexOf("quantity") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                classNamePrefix="prescription"
                                value={
                                  data?.quantity
                                    ? {
                                      value: data?.quantity,
                                      label: data?.quantity,
                                    }
                                    : ""
                                }
                                isRtl={lang === "HE"}
                                noOptionsMessage={() =>
                                  t("Type a number between 1-10")
                                }
                                styles={customStyles}
                                isSearchable={true}
                                options={quantityArray}
                                name="quantity"
                                placeholder="Select"
                                onChange={(e) =>
                                  handleinputchange(
                                    {
                                      target: {
                                        name: "quantity",
                                        value: e.value,
                                      },
                                    },
                                    i
                                  )
                                }
                              />
                            </Form.Group>
                          </div>

                          <h2> {t("Instruction of use")}</h2>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <Form.Group className="frequency new-field">
                              <Form.Label>
                                {" "}
                                {isSyrup[i]
                                  ? t(
                                    "Dosage - Please note, the desired quantity must be written in ml"
                                  )
                                  : t(
                                    "Dosage - amount of units, not amount of active ingredient"
                                  )}{" "}
                                <CustomToolTip
                                  title={t(
                                    "Dosage: The number of units to be taken for each occasion of taking the medicine"
                                  )}
                                  id="dosage"
                                >
                                  ?{" "}
                                </CustomToolTip>{" "}
                              </Form.Label>

                              <Form.Control
                                className={` ${errors[i]?.indexOf("dosage") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                name="dosage"
                                onKeyDown={(e) =>
                                  e.key === "-" && e.preventDefault()
                                }
                                type="number"
                                min="0"
                                onChange={(e) => handleinputchange(e, i)}
                                id="dosage"
                                placeholder={
                                  isSyrup[i]
                                    ? t(
                                      "Dosage - Please note, the desired quantity must be written in ml"
                                    )
                                    : t(
                                      "Dosage - amount of units, not amount of active ingredient"
                                    )
                                }
                                value={data?.dosage}
                                style={{
                                  textAlign: lang === "HE" ? "right" : "left",
                                }}
                              />
                            </Form.Group>
                            <Form.Group className="frequency new-field" />
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <Form.Group className="frequency">
                              <Form.Label>
                                {" "}
                                {t("Times")}{" "}
                                <CustomToolTip
                                  title={t(
                                    "The number of doses to be taken per unit of time according to the frequency in the next field"
                                  )}
                                  id="times"
                                >
                                  ?{" "}
                                </CustomToolTip>
                              </Form.Label>
                              <Select
                                className={` ${errors[i]?.indexOf("frequency") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                classNamePrefix="prescription"
                                value={
                                  data?.frequency
                                    ? {
                                      value: data.frequency,
                                      label: data.frequency,
                                    }
                                    : ""
                                }
                                isRtl={lang === "HE"}
                                placeholder="Select"
                                noOptionsMessage={() =>
                                  t("Type a number between 1-10")
                                }
                                styles={customStyles}
                                isSearchable={true}
                                options={timesArray}
                                name="frequency"
                                onChange={(e) =>
                                  handleinputchange(
                                    {
                                      target: {
                                        name: "frequency",
                                        value: e.value,
                                      },
                                    },
                                    i
                                  )
                                }
                              />
                            </Form.Group>
                            <Form.Group className="frequency">
                              <Form.Label>
                                {" "}
                                {t("Frequency")}{" "}
                                <CustomToolTip
                                  title={t(
                                    "The time unit as defined in relation to the number in the previous field"
                                  )}
                                  id="times"
                                >
                                  ?{" "}
                                </CustomToolTip>
                              </Form.Label>
                              <Select
                                className={` ${errors[i]?.indexOf("frequencyUnit") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                classNamePrefix="prescription"
                                value={
                                  data.frequencyUnit
                                    ? {
                                      value: t(data.frequencyUnit),
                                      label: t(data.frequencyUnit),
                                    }
                                    : ""
                                }
                                isRtl={lang === "HE"}
                                styles={customStyles}
                                isSearchable={true}
                                options={frequencyArray}
                                placeholder="Select"
                                name="frequencyUnit"
                                onChange={(e) =>
                                  handleinputchange(
                                    {
                                      target: {
                                        name: "frequencyUnit",
                                        value: e.value,
                                      },
                                    },
                                    i
                                  )
                                }
                              />
                            </Form.Group>
                          </div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <Form.Group className="frequency">
                              <Form.Label>
                                {" "}
                                {t("Period")}{" "}
                                <CustomToolTip
                                  title={t(
                                    "For a period of: the number of days/weeks the patient has to repeat taking the medicine"
                                  )}
                                  id="times"
                                >
                                  ?{" "}
                                </CustomToolTip>{" "}
                              </Form.Label>
                              <Select
                                className={` ${errors[i]?.indexOf("duration") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                classNamePrefix="prescription"
                                value={
                                  data?.duration
                                    ? handlePeriodArray()[
                                    Number(data?.duration) - 1
                                    ]
                                    : null
                                }
                                isRtl={lang === "HE"}
                                noOptionsMessage={() =>
                                  t("Enter a number between 1-180")
                                }
                                styles={customStyles}
                                isSearchable={true}
                                options={handlePeriodArray()}
                                placeholder="Select"
                                name="duration"
                                onChange={(e) =>
                                  handleinputchange(
                                    {
                                      target: {
                                        name: "duration",
                                        value: e.value,
                                      },
                                    },
                                    i
                                  )
                                }
                              />
                            </Form.Group>
                            <Form.Group className="frequency">
                              <Form.Label>
                                {" "}
                                {t("Duration for")}{" "}
                                <CustomToolTip
                                  title={t(
                                    "Duration: the unit of measure (day/week...) that refers to the previous field"
                                  )}
                                  id="times"
                                >
                                  ?{" "}
                                </CustomToolTip>
                              </Form.Label>
                              <Select
                                className={` ${errors[i]?.indexOf("durationUnit") > -1
                                    ? "red-border"
                                    : ""
                                  }`}
                                classNamePrefix="prescription"
                                value={
                                  data?.durationUnit
                                    ? {
                                      value: t(data?.durationUnit),
                                      label: t(data?.durationUnit),
                                    }
                                    : ""
                                }
                                isRtl={lang === "HE"}
                                noOptionsMessage={() =>
                                  data.frequencyUnit
                                    ? t("No option available")
                                    : t("Please select frequency first")
                                }
                                styles={customStyles}
                                isSearchable={true}
                                options={getFilteredDurationOptions(
                                  data.frequencyUnit
                                )}
                                placeholder="Select"
                                name="durationUnit"
                                autoComplete={true}
                                onChange={(e) =>
                                  handleinputchange(
                                    {
                                      target: {
                                        name: "durationUnit",
                                        value: e.value,
                                      },
                                    },
                                    i
                                  )
                                }
                              />
                            </Form.Group>
                          </div>

                          {/*==================== doctor and patient meta details for IsSam Start here ======================*/}

                          {medicMetaDetails[i] && (
                            <>
                              <h2> {t("Patient Details")}</h2>
                              {!showPatientInputField ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("Street")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("patient_street") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="patient_street"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="patient_street"
                                        placeholder={t("Street")}
                                        value={
                                          formValue?.patient_street ||
                                          data?.patient_street
                                        }
                                      />
                                    </Form.Group>

                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("House No")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf(
                                          "patient_houseno"
                                        ) > -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="patient_houseno"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="patient_houseno"
                                        placeholder={t("House No")}
                                        value={
                                          formValue?.patient_houseno ||
                                          data?.patient_houseno
                                        }
                                      />
                                    </Form.Group>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("City")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("patient_city") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="patient_city"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="patient_city"
                                        placeholder={t("City")}
                                        value={
                                          formValue?.patient_city ||
                                          data?.patient_city
                                        }
                                      />
                                    </Form.Group>

                                    <Form.Group className="frequency new-field">
                                      <Form.Label>
                                        {" "}
                                        {t("Postal Code")}{" "}
                                      </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf(
                                          "patient_pincode"
                                        ) > -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="patient_pincode"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="patient_pincode"
                                        placeholder={t("Postal Code")}
                                        value={
                                          formValue?.patient_pincode ||
                                          data?.patient_pincode
                                        }
                                      />
                                    </Form.Group>
                                  </div>

                                  {/* <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label>
                                        {" "}
                                        {t("Date of Birth")}{" "}
                                      </Form.Label>

                                      <LocalizationProvider
                                        dateAdapter={AdapterMoment}
                                      >
                                        <DatePicker
                                          slotProps={{
                                            field: {
                                              clearable: true,
                                              onClear: () => setCleared(true),
                                            },
                                          }}
                                          views={["year", "month", "day"]}
                                          onChange={(e) =>
                                            onMedicineMetaDOBChange(
                                              e,
                                              i,
                                              "patient_dob"
                                            )
                                          }
                                          value={
                                            data?.patient_dob
                                              ? data?.patient_dob
                                              : formValue?.clientDOB
                                          }
                                          disableFuture
                                          format="DD/MM/YYYY"
                                          inputFormat="DD/MM/YYYY"
                                          className="rx-dob"
                                          // openTo="year"
                                        />
                                      </LocalizationProvider>
                                    </Form.Group>

                               <Form.Group className="frequency new-field">
                                      <Form.Label> {t("Gender")} </Form.Label>
                               

                                      <Select
                                        className={` ${
                                          errors[i]?.indexOf("patient_gender") >
                                          -1
                                            ? "red-border"
                                            : ""
                                        }`}
                                        classNamePrefix="prescription"
                                        defaultValue={
                                          data?.patient_gender
                                            ? {
                                                value: data?.patient_gender
                                                  ? data?.patient_gender
                                                  : formValue?.clientGender,
                                                label: data?.patient_gender
                                                  ? t(data?.patient_gender)
                                                  : t(formValue?.clientGender),
                                              }
                                            : ""
                                        }
                                        isRtl={lang === "HE"}
                                        noOptionsMessage={() =>
                                          t(
                                            "Please select your gender Male/Female"
                                          )
                                        }
                                        styles={customStyles}
                                        isSearchable={true}
                                        options={genderArr}
                                        name="patient_gender"
                                        placeholder="Select"
                                        onChange={(e) =>
                                          handleinputchange(
                                            {
                                              target: {
                                                name: "patient_gender",
                                                value: e.value,
                                              },
                                            },
                                            i
                                          )
                                        }
                                      />
                                    </Form.Group> 
                                  </div> */}
                                </>
                              ) : (
                                <Form.Group
                                  className="frequency"
                                  style={{ width: "100%", margin: "0px" }}
                                >
                                  <Form.Label>{t("Address")}</Form.Label>

                                  <div
                                    className={`doctor-address ${lang === "EN" ? "eng-text" : ""
                                      }`}
                                  >
                                    <Form.Label>
                                      {combinePatientAddress}
                                    </Form.Label>
                                    <Button
                                      onClick={() =>
                                        handlePatientEditInputField()
                                      }
                                    >
                                      {t("Edit")}
                                    </Button>
                                  </div>
                                </Form.Group>
                              )}

                              <h2> {t("Doctor Details")}</h2>

                              {!showInputField ? (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("Street")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("doctor_street") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="doctor_street"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="doctor_street"
                                        placeholder={t("Street")}
                                        defaultValue={
                                          medicineMetaDocData?.clientAddress
                                            ?.street
                                        }
                                      />
                                    </Form.Group>
                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("House No")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("doctor_houseno") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="doctor_houseno"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="doctor_houseno"
                                        placeholder={t("House No")}
                                        defaultValue={
                                          medicineMetaDocData?.clientAddress
                                            ?.house
                                        }
                                      />
                                    </Form.Group>
                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label> {t("City")} </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("doctor_city") > -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="doctor_city"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="doctor_city"
                                        placeholder={t("City")}
                                        defaultValue={
                                          medicineMetaDocData?.clientAddress
                                            ?.city
                                        }
                                      />
                                    </Form.Group>
                                    <Form.Group className="frequency new-field">
                                      <Form.Label>
                                        {" "}
                                        {t("Postal Code")}{" "}
                                      </Form.Label>
                                      <Form.Control
                                        className={` ${errors[i]?.indexOf("doctor_pincode") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="doctor_pincode"
                                        type="text"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        id="doctor_pincode"
                                        placeholder={t("Postal Code")}
                                        defaultValue={
                                          medicineMetaDocData?.clientAddress
                                            ?.pincode
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Form.Group className="frequency new-field">
                                      <Form.Label>
                                        {" "}
                                        {t("Clinic phone number")}{" "}
                                      </Form.Label>
                                      <Form.Control
                                        className={`phone_number ${errors[i]?.indexOf("doctor_phone") >
                                            -1
                                            ? "red-border"
                                            : ""
                                          }`}
                                        name="doctor_phone"
                                        type="text"
                                        id="doctor_phone"
                                        placeholder={t("Clinic phone number")}
                                        pattern="[+0-9 -]+"
                                        onChange={(e) =>
                                          handleinputchange(e, i)
                                        }
                                        value={data?.doctor_phone}
                                      />
                                    </Form.Group>
                                  </div>
                                </>
                              ) : (
                                <Form.Group
                                  className="frequency ddd"
                                  style={{ width: "100%", margin: "0px" }}
                                >
                                  <Form.Label>{t("Address")}</Form.Label>

                                  <div
                                    className={`doctor-address ${lang === "EN" ? "eng-text" : ""
                                      }`}
                                  >
                                    <Form.Label>{combineAddress}</Form.Label>
                                    <Button
                                      onClick={() => handleEditInputField()}
                                    >
                                      {t("Edit")}
                                    </Button>
                                  </div>
                                </Form.Group>
                              )}
                            </>
                          )}

                          <Form.Group>
                            <Form.Label> {t("Remarks")}</Form.Label>
                            <textarea
                              className={`form-control ${errors[i]?.indexOf("remarks") > -1
                                  ? "red-border"
                                  : ""
                                }`}
                              id="remarks"
                              name="remarks"
                              defaultValue={data ? data.remarks : ""}
                              onChange={(e) => handleinputchange(e, i)}
                              placeholder={t("Remarks")}
                              autoComplete="off"
                              maxLength={200}
                            />
                            <p>{data?.remarks?.length || "0"}/200</p>
                          </Form.Group>
                          <br></br>
                          {prescriptionData.length - 1 === i && (
                            <Button
                              onClick={() => handleaddclick()}
                              className="buttton_content"
                              tabIndex={-1}
                            >
                              {t("Add More")}
                            </Button>
                          )}
                          {prescriptionData.length != 0 && (
                            <Button
                              variant="danger"
                              className="removebuttton_content"
                              onClick={() => handleremove(data, i)}
                              style={{ margin: " 0 10px" }}
                              tabIndex={-1}
                            >
                              {t("Remove")}
                            </Button>
                          )}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <Button
                    onClick={() => handleaddclick()}
                    className="buttton_content"
                    tabIndex={-1}
                  >
                    {t("Add New")}
                  </Button>
                )}
              </Form>
            </>
          )}
          <div className="two_button">
            <div className="two_button-left">
              {doctorData.signatureCredentials ?
                <Button
                  variant="primary"
                  size="lg"
                  className="buttton_content save_sammary_press"
                  onClick={signandsend}
                  tabIndex={-1}
                  disabled={
                    (key === "Prescription" && prescriptionData?.length === 0) ||
                    (key === "Summary" && !isNewValue) || isLoader
                  }
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    t("Finishing and sending")
                  )}
                </Button> : 
              <Button
                variant="primary"
                size="lg"
                className="buttton_content save_sammary_press"
                onClick={signandsend}
                tabIndex={-1}
                disabled={
                  (key === "Prescription" && prescriptionData?.length === 0) ||
                  (key === "Summary" && !isNewValue)
                }
              >
                {t("Sign and send summary to patient")}
                </Button>}
              {key === "Summary" ? (
                <>
                  {summaryFieldArray.length < 5 ? (
                    <Button
                      variant="primary"
                      size="lg"
                      className="buttton_content save_sammary_press"
                      onClick={() => handleFieldModal()}
                    >
                      {t("Add Field")} <AddIcon />
                    </Button>
                  ) : (
                    <>
                      <Button
                        variant="primary"
                        size="lg"
                        className="buttton_content save_sammary_press"
                        onClick={() => handleFieldModal()}
                      >
                        {t("Edit Field")} <EditIcon />
                      </Button>
                    </>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </>
      </div>
    </>
  );
};

export default RxSummaryComponent;
